import { request } from "@/utils/request";
import useSWR from "swr";

interface ResponseDeFutures {
  data: {
    trading_volume: string;
    total_fee: string;
  };
}

async function fetchDeFuture(url: string) {
  const response = await request(url);
  const data = await response.json();
  return data as ResponseDeFutures;
}

export function useDeFuture() {
  const data = useSWR("/stats/defutures", fetchDeFuture, {
    refreshInterval: 15_000,
    errorRetryInterval: 10_000,
  });

  return data;
}
